// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

const STROKE = '1px';

export const Base = styled.div`
    background-color: transparent;
    outline: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
`;

export const TabContainer = styled.div`
    border-bottom: solid ${STROKE} ${p => p.theme.secondaryMedium};
    margin: 1em 0;
    transition: border-color 0.1s ease-out;

    ${Base}:focus & {
        border-bottom-color: ${p => p.theme.secondaryHeavy};
    }
`;

export const List = styled.ul`
    display: flex;
    margin: 0 auto;
    padding: 0 1em;
    position: relative;
    max-width: ${p => (p.maxWidth ? p.theme.layoutMaxWidth : '100%')};
`;

export const Item = styled.li`
    background-color: ${p => p.theme.white};
    border: solid ${STROKE} ${p => p.theme.secondaryMedium};
    border-bottom-color: ${p => (p.selected ? p.theme.white : p.theme.secondaryMedium)};
    border-radius: 1em 1em 0 0;
    cursor: ${p => (p.selected ? 'inherit' : 'pointer')};
    display: flex;
    flex: 0 1 10em;
    height: 3em;
    justify-content: center;
    margin: 0 0.3em;
    position: relative;
    top: ${STROKE};
    transition: background-color 0.1s ease-out, border-color 0.1s ease-out;

    &:hover {
        background-color: ${p => (p.selected ? p.theme.white : p.theme.lightGrey)};
    }
    ${Base}:focus & {
        border-color: ${p => p.theme.secondaryHeavy};
        border-bottom-color: ${p => (p.selected ? p.theme.white : p.theme.secondaryHeavy)};
    }

    a,
    div {
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;
        color: ${p => (p.selected ? 'inherit' : p.theme.heavyGrey)};
        text-decoration: none;
    }

    a {
        width: 100%;
        height: 100%;
    }
`;

export const TabIcon = styled(SVGIcon)`
    height: 1.3em;
    margin-bottom: 0.1em;
    transition: fill 0.1s ease-out;
    width: 1.3em;

    & > g {
        fill: ${p => (p.selected ? p.theme.mainBrandColor : p.theme.fontColor)};
    }
`;

export const Label = styled.div`
    font-size: 0.9em;
    user-select: none;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/tabs/styles.js